export const environment = {
  production: false,
  apiUrl: 'https://p2p-api-test.paynet.md',
  oplatamdURL: 'https://test.oplata.md',
  pspURL: 'https://psp-test.paynet.md',
  RECAPTCHA_SITE_KEY: '6LeIbRUnAAAAAPtndZrRUndlAaxbNZQnj3RQRIEG',
};
